import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { faBan, faMugHot, faBowlFood, faUtensils, faChampagneGlasses } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LangHelper from '../../../../helpers/lang-helper';

const BOARD_CONFIG = {
  1: { icon: faBan,               color: '#888888' },
  2: { icon: faMugHot,            color: '#d97706' },
  3: { icon: faBowlFood,          color: '#ea580c' },
  4: { icon: faUtensils,          color: '#2563eb' },
  5: { icon: faChampagneGlasses,  color: '#16a34a' },
};

const RoomBoardType = ({ boardType }) => {
  const { t } = useTranslation();
  const label = t(LangHelper.getBoardTypeLangKey(boardType));

  if (!label) return null;

  const config = BOARD_CONFIG[+boardType];
  if (!config) return null;

  return (
    <span className="board-type-chip" style={{ '--chip-color': config.color }}>
      <FontAwesomeIcon icon={config.icon} />
      {label}
    </span>
  );
};

RoomBoardType.propTypes = {
  boardType: PropTypes.number,
};

export default RoomBoardType;
